import Layout from '@/layout/base/layoutSegfy'

// Telas NOVAS de busca (react-gestao): a rota carrega a página hospedeira do app novo
// (produto.segfy.com, Pages/Buscas), que consulta o módulo da tela e embute o React — ou
// devolve para a rota -classico abaixo quando a corretora não tem o módulo. Por isso cada
// tela nova tem a sua rota -classico: sem ela a hospedeira devolveria para a rota principal,
// que é ela própria, e as duas ficariam se empurrando.
const hospedeira = (pagina) => `${process.env.VUE_APP_NEW_SERVER}/Buscas/${pagina}`

export default [{
    path: '/buscas',
    component: Layout,
    children: [
        {
            name: 'busca-extrato',
            path: 'extratos',
            component: () => import('@/components/common/reactEmbed'),
            props: {
                url: hospedeira('Extratos'),
                title: 'Busca de Extratos'
            },
            meta: {
                auth: true,
                needsPermission: 'acessoRecebimento' // a permissão de Recebimento se aplica para a busca de extratos
            }
        },
        {
            // Tela Vue anterior, destino de quem nao tem o modulo (a hospedeira do app novo devolve para ca).
            name: 'busca-extrato-classico',
            path: 'extratos-classico',
            component: () => import('@/components/buscas/extratos/busca'),
            meta: {
                auth: true,
                needsPermission: 'acessoRecebimento'
            }
        },
        {
            name: 'importar-extrato',
            path: 'extratos/importar',
            component: () => import('@/components/buscas/extratos/importar'),
            meta: {
                auth: true
            }
        },
        {
            name: 'busca-parcela',
            path: 'parcelas',
            component: () => import('@/components/common/reactEmbed'),
            props: {
                url: hospedeira('Parcelas'),
                title: 'Parcelas Atrasadas'
            },
            meta: {
                auth: true,
                needsPermission: 'acessoParcelaAtrasada'
            }
        },
        {
            // Tela Vue anterior, destino de quem nao tem o modulo (a hospedeira do app novo devolve para ca).
            name: 'busca-parcela-classico',
            path: 'parcelas-classico',
            component: () => import('@/components/buscas/parcelas/busca'),
            meta: {
                auth: true,
                needsPermission: 'acessoParcelaAtrasada'
            }
        },
        {
            name: 'busca-propostas',
            path: 'propostas',
            component: () => import('@/components/common/reactEmbed'),
            props: {
                url: hospedeira('Propostas'),
                title: 'Busca de Propostas'
            },
            meta: {
                auth: true,
                needsPermission: 'acessoBuscaDocumentos'
            }
        },
        {
            name: 'busca-apolices',
            path: 'apolices',
            component: () => import('@/components/common/reactEmbed'),
            props: {
                url: hospedeira('Apolices'),
                title: 'Busca de Apólices'
            },
            meta: {
                auth: true,
                needsPermission: 'acessoBuscaDocumentos'
            }
        },
        {
            // Tela Vue anterior, destino de quem nao tem o modulo (a hospedeira do app novo devolve para ca).
            name: 'busca-propostas-classico',
            path: 'propostas-classico',
            component: () => import('@/components/buscas/propostas/buscaDocs'),
            meta: {
                auth: true,
                needsPermission: 'acessoBuscaDocumentos'
            }
        },
        {
            // Tela Vue anterior, destino de quem nao tem o modulo (a hospedeira do app novo devolve para ca).
            name: 'busca-apolices-classico',
            path: 'apolices-classico',
            component: () => import('@/components/buscas/apolices/buscaDocs'),
            meta: {
                auth: true,
                needsPermission: 'acessoBuscaDocumentos'
            }
        },
        {
            name: 'busca-docs',
            path: 'docs',
            component: () => import('@/components/buscas/propostas/busca'),
            meta: {
                auth: true
            }
        },
        {
            name: 'importar-documentos',
            path: 'documentos/importar',
            component: () => import('@/components/buscas/propostas/importar'),
            meta: {
                auth: true
            }
        }
    ]
}]
